import React from 'react';
import { Select } from '@tencent/spaui';
import _ from 'lodash';
import { connect } from 'react-redux';
import perms from '@/common/permissions/sale/perms';

// 推广经验

const initData = [
  // {
  //   label: '信息流推广经验',
  //   value: 1,
  //   'data-report': 'industry-select-tree-options-1',
  // },
  {
    label: '搜索推广经验',
    value: 2,
    'data-report': 'industry-select-tree-options-2',
  },
  // {
  //   label: '信息流或搜索推广经验',
  //   value: 3,
  //   'data-report': 'industry-select-tree-options-3',
  // },
  // {
  //   label: '信息流且搜索推广经验',
  //   value: 4,
  //   'data-report': 'industry-select-tree-options-4',
  // },
];

// const value2label = {};
//
// initData.forEach(({ label, value }) => {
//   value2label[value] = label;
// });

class LeadMarkSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  onChange = (e, value) => {
    const { onChange } = this.props;
    const select = {
      competitorTags: value,
    };
    onChange?.(select);
  }

  onClear = (e, value) => {
    const { onClear } = this.props;
    onClear?.({
      competitorTags: null,
    });
  }

  render() {
    const { value } = this.props;
    return (
      <Select
        data-report='lead-promote-experience'
        clear={true}
        onClear={this.onClear}
        data={initData}
        value={value}
        onChange={this.onChange}
      />
    );
  }
}

const render = (value) => {
  return <div style={{ fontWeight: 'bolder', color: '#fa8e00' }}>{value}</div>;
};

const RenderData = (props) => {
  const {
    value,
    loginStatus,
  } = props;
  // 服务商维度灰度展示推广经验
  const leadPromoteExperiencePerms = _.includes(loginStatus.grayPermissions, perms.GRAY_SEAS_LEAD_PROMOTE);
  if (!leadPromoteExperiencePerms) {
    return '-';
  }
  // console.log('value', value);
  if (_.isEmpty(value)) {
    return '-';
  }
  if (Array.isArray(value)) {
    return render(value.map((item) => item.leadTagName).join(','));
  }
  return render(value);
};

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const RenderLeadPromoteExperience = connect(mapStateToProps, mapDispatchToProps)(RenderData);
export default LeadMarkSelect;
